import { Component, Output, EventEmitter, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ControlContainer, UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { SlideadjustmentunitpriceInfo, SlideadjustmentunitpriceLstInfoDto } from 'sg-api';
import { DisplayMode } from 'cbc-shared-lib';
import { MatSort } from '@angular/material/sort';

/**
 * 再エネ賦課金単価登録画面(登録状況一覧)
 * @exports
 * @class CalendarMasterSearchComponent
 * @implements {OnInit, OnDestroy}
 */
@Component({
    selector: 'app-sgkc034d-re-energy-tanka-result-list',
    templateUrl: './sgkc034d-re-energy-tanka-result-list.component.html',
    styleUrl: './sgkc034d-re-energy-tanka-result-list.component.scss',
    providers: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgkc034dReEnergyTankaResultListComponent implements OnInit, OnDestroy {
    /** テーブルのソート機能 */
    @ViewChild('sort', { static: true }) sort: MatSort;
    /** 親コンポーネント保持領域 */
    parentForm: UntypedFormGroup;
    /** スライド調整単価一覧情報リスト */
    @Input() slideadjustmentunitpriceLstInformationlist: SlideadjustmentunitpriceLstInfoDto[];
    /** 画面モード */
    @Input() mode: string;
    /** 行ダブルクリックイベント */
    @Output() onDbClickRowEvent = new EventEmitter<SlideadjustmentunitpriceLstInfoDto>();
    /** 検索結果表示データソース */
    dataSource = new MatTableDataSource<SlideadjustmentunitpriceLstInfoDto>();
    /** 検索結果表示リスト */
    displayedColumnsCol: string[] = [
        'apprvStsAname',
        'applyYm',
        'applyStartDate',
        'applyEndDate',
        'slideadjustmentunitprice',
    ];

    /** 
    * コンストラクタ
    * @memberof Sgkc034dReEnergyTankaResultListComponent
    */
    constructor() {
    }

    /** 
     * 初期処理
     * @memberof Sgkc034dReEnergyTankaResultListComponent
     */
    ngOnInit(): void {
        this.dataSource.data = this.slideadjustmentunitpriceLstInformationlist.slice(0, 10); // 先頭10件だけ表示;
    }

    /** 
     * 破棄処理
     * @memberof Sgkc034dReEnergyTankaResultListComponent
     */
    ngOnDestroy(): void {
    }

    /** 
     * ビュー初期化後処理
     * @memberof Sgkc034dReEnergyTankaResultListComponent
     */
    ngAfterViewInit() {
        this.dataSource.sort = this.sort;
    }

    /** 
     * 行ダブルクリックイベント
     * @param {SlideadjustmentunitpriceInfo} row - ダブルクリックされた行のデータ
     * @memberof Sgkc034dReEnergyTankaResultListComponent
     */
    onDbClickRow(row: SlideadjustmentunitpriceInfo): void {
        if (this.mode === DisplayMode.read) {
            this.onDbClickRowEvent.emit(row);
        }
    }
}